import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateForm($id: Int!, $sendResponsesTo: [sendResponseToInput!]) {
    updateForm(data: { id: $id, sendResponsesTo: $sendResponsesTo }) {
      id
      slug
      sendResponsesTo {
        email
      }
    }
  }
`);

export interface UpdateGql {
  updateForm: {
    id: number;
    slug: string;
    sendResponsesTo: {
      email: string;
    }[];
  };
}
